// extracted by mini-css-extract-plugin
export default {"box":"AddressForm_box__eyhr4","country":"AddressForm_country__MAKO-","ltr":"AddressForm_ltr__xGs31"};